/* libs */
import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

/* action helpers */
import * as ActionTypes from "../../actions/actionTypes";
import * as PagesActions from "../../actions/pagesActions";
import * as constants from "../../constants";

const selectPageLogic = createLogic({
	type: ActionTypes.SELECT_PAGE,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		//TODO: dispatch action for creating a loader
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});

				api.get(`/pages/${action.page}`)
					.then(res => {
						//TODO: dispatch action for stopping loader
						dispatch(PagesActions.selectPageSuccess(res.data));
						done();
					})
					.catch(error => {
						//TODO: dispatch action for stopping loader
						dispatch(PagesActions.selectPageFailure(error));
						done();
					});
			});
	},
});

export default [selectPageLogic];
